import React, { useState, useEffect, useMemo } from 'react';
import { debounce, isEmpty, sortBy } from 'lodash';

import Badge from '../v2/Badge';
import AutoCompleteSearch from './autocomplete-search';

const CustomerTypeLabel = ({ userType }) => {
  let color = 'grey';

  if (userType === 'Shipper') {
    color = 'green';
  } else if (userType === 'Carrier') {
    color = 'blue';
  } else if (userType === 'Driver') {
    color = 'blue';
  }

  return <Badge color={color}>{userType}</Badge>;
};

const renderCustomer = (customer, label) => {
  return (
    <a
      key={customer._id}
      id={customer._id}
      className="list-group-item cursor-pointer"
    >
      <div className="flex">
        <div style={{ minWidth: 80 }}>
          <CustomerTypeLabel userType={customer._type} />
        </div>
        <span className="form-label px-2">{label}</span>
        {customer.is_broker && (
          <div style={{ minWidth: 80 }}>
            <Badge color="orange">Broker</Badge>
          </div>
        )}
      </div>
    </a>
  );
};

/*
 * An autocomplete component for searching customers
 */
export default function CustomerSearchFilter({
  searchCustomers,
  searchField,
  placeholder,
  onSelect,
  clearOnSelect,
}) {
  const [query, setQuery] = useState({});
  const [customers, setCustomers] = useState([]);

  function onSearch(nGram) {
    setQuery({ ...query, [searchField]: nGram });
  }

  function getItemValue(item) {
    return item[searchField];
  }

  const debouncedQuery = useMemo(() => {
    return debounce(async (query) => {
      const customers = await searchCustomers(query);
      setCustomers(sortBy(customers, searchField));
    }, 350);
  }, []);

  useEffect(() => {
    if (!isEmpty(query)) {
      debouncedQuery(query, searchField);
    }
  }, [query]);

  return (
    <div>
      <AutoCompleteSearch
        onSearch={onSearch}
        onSelect={onSelect}
        items={customers}
        placeholder={placeholder}
        renderItem={(item) => renderCustomer(item, item[searchField])}
        clearOnSelect={clearOnSelect}
        getItemValue={getItemValue}
      />
    </div>
  );
}
